export default __webpack_public_path__ + "static/media/Emojis14.90aadc5e.png";